import { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Spin } from 'antd';
import { trpc } from '../../lib/api';
import { usePartnerAuthStore } from '../../stores/partnerAuthStore';
import { isAuthError } from './authGuardUtils';

interface PartnerAuthGuardProps {
  children: React.ReactNode;
}

export function PartnerAuthGuard({ children }: PartnerAuthGuardProps) {
  const location = useLocation();
  const { isAuthenticated, clearAuth, token } = usePartnerAuthStore();

  const { isLoading, error } = trpc.partnerAuth.me.useQuery(
    { token: token || '' },
    {
      enabled: isAuthenticated && !!token,
      retry: false,
    }
  );

  useEffect(() => {
    if (error && isAuthError(error)) {
      clearAuth();
    }
  }, [error, clearAuth]);

  if (isLoading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
      }}>
        <Spin size="large" />
      </div>
    );
  }

  if (!isAuthenticated || !token) {
    return <Navigate to="/partner/login" state={{ from: location }} replace />;
  }

  return <>{children}</>;
}
